import React from 'react';
import { Box, Breadcrumbs, Container, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';

const InstallShippers = () => {
  const title = "Windows Shippers";
  const navigate = useNavigate();

  const handleBreadcrumbClick = () => {
    navigate('/shippers');
  }

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title={ title }></PageHeader>
      </Box>
      <Box sx={{ mt: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="#c1d4e7" onClick={handleBreadcrumbClick} sx={{ '&:hover': { cursor: 'pointer' } }}>
                  Shippers
              </Link>
              <Typography color="white"> / </Typography>
              <Typography color="white">{ title }</Typography>
          </Breadcrumbs>
      </Box>
      <Box
        sx={{
          maxWidth: 1000,
          margin: 'auto',
          p: 3,
          mt: 8,
          border: '1px solid #ccc',
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: '#1A1A1A',
        }}
      >
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Install Instructions
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary="1. Extract the contents of the package containing the shippers. It should contain a folder labeled 'shippers_x86_64' as well as a script labeled 'Run_This'."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="2. Within the location that the package was extracted to, right-click the script file labeled 'Run_This' and select 'Run with PowerShell'."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="3. When prompted to change Execution Policy, type 'A' and hit the 'Enter' key."
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="4. The install should prompt for Administrator permission, enter Administrator credentials if not logged in as an Administrator, or hit 'Yes' to allow the install script to run if already logged in as an Administrator."
            />
          </ListItem>
        </List>
        <Typography variant="body1" mt={2}>
          The install should run smoothly with no errors and should start the shippers automatically. If you encounter any problems, please contact us at{' '}
          <Typography component="span" fontWeight="bold">support@cancgroup.com</Typography>.
        </Typography>
      </Box>
    </Container>
  );
};

export default InstallShippers;
